import '../less/components.less'
import './input-passengers'
import './phone-control'
import './search-filter-form'
import './filters-left-sidebar'

const title1 = document.getElementById('title1')
const title2 = document.getElementById('title2')
const content1 = document.getElementById('content1')
const content2 = document.getElementById('content2')
const signAction = document.getElementById('signAction')

signAction?.addEventListener('click', () => {
    if (title1.classList.contains('hidden-submit') && content1.classList.contains('hidden-submit')) {
        title1.classList.remove('hidden-submit')
        title2.classList.add('hidden-submit')
        content1.classList.remove('hidden-submit')
        content2.classList.add('hidden-submit')
    } else {
        title1.classList.add('hidden-submit')
        title2.classList.remove('hidden-submit')
        content1.classList.add('hidden-submit')
        content2.classList.remove('hidden-submit')
    }
})

const closeButton = document.getElementById('closeDropdown')
const dropdownContent = document.getElementById('dropdownContent')

// Cerrar el dropdown al hacer clic en el botón "Cerrar"
closeButton?.addEventListener('click', () => {
    dropdownContent.classList.remove('show')
})


//Special Offers
jQuery('.special-carousel').owlCarousel({
    loop: false,
    nav: true,
    item: 1,
    margin: 25,
    navText: ["<i class='ph ph-arrow-left'></i>", "<i class='ph ph-arrow-right'></i>"],
    dots: false,
    responsive: {
        0: {
            items: 1
        }
    }
})


jQuery(".range-slider.price_range").ionRangeSlider({
    type: "double",
    min: 989,
    max: 3189,
    from: 989,
    to: 3189,
    step: 100,
    prefix: "£"
})

jQuery('#airline-name').on('change', function () {
    if (document.querySelector('#airline-name').value === '2') {
        const airport = document.querySelector('#departure-air')
        const options = airport.querySelectorAll('option')
        console.log(options[1])

        options[1].selected = true
        console.log(airport.value)
        console.log(options[1].selected === true)

        jQuery('#departure-air').niceSelect('destroy')
        jQuery('#departure-air').niceSelect()

    }
})

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))